import { render } from "./NotificationsPage.vue?vue&type=template&id=2102163c&scoped=true"
import script from "./NotificationsPage.vue?vue&type=script&lang=js"
export * from "./NotificationsPage.vue?vue&type=script&lang=js"

import "./NotificationsPage.vue?vue&type=style&index=0&id=2102163c&scoped=true&lang=less"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2102163c"]])

export default __exports__